import { Badge, type BadgeVariant } from '../../../../components/ui/Badge/Badge';
import type { SkipEnquiryStatus } from '../../../../types/api';

const STATUS_LABELS: Record<SkipEnquiryStatus, string> = {
  open: 'Open',
  contacted: 'Contacted',
  no_answer: 'No Answer',
  quoted: 'Quoted',
  converted: 'Converted',
  cancelled: 'Cancelled',
  expired: 'Expired',
};

const STATUS_VARIANTS: Record<SkipEnquiryStatus, BadgeVariant> = {
  open: 'info',
  contacted: 'warning',
  no_answer: 'warning',
  quoted: 'info',
  converted: 'success',
  cancelled: 'muted',
  expired: 'muted',
};

export interface SkipEnquiryStatusBadgeProps {
  status: SkipEnquiryStatus;
}

export function SkipEnquiryStatusBadge({ status }: SkipEnquiryStatusBadgeProps): JSX.Element {
  return <Badge variant={STATUS_VARIANTS[status]}>{STATUS_LABELS[status]}</Badge>;
}
